//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Message = (function () {
    var myMessage = {
        Init: function () {
            $('#btnAlreadyUpdated').on('click', function () {
                var updateUrl = $(this).data('update-url');
                var button = $(this);
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: updateUrl,
                    success: function (tmp) {
                        $(button).closest('.card').fadeOut(500)
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                        console.log(JSON.stringify(jqXHR));
                    }
                });
            });

            $(document).on("click", "[data-close-card]", function () {
                $(this).closest(".card").hide();
            });
        },
    };
    return myMessage;
}());